<template>
  <div class="examination">
    <!-- 查询 -->
    <!-- <el-form :inline="true" :model="formInline" class="demo-form-inline">
     <el-form-item label="题目名称:">
       <el-input v-model="formInline.user" placeholder="题目名称"></el-input>
     </el-form-item>
     <el-form-item label="发布老师:">
       <el-input v-model="formInline.user" placeholder="发布老师"></el-input>
     </el-form-item>
    <el-form-item label="类型:">
       <el-select v-model="formInline.region" placeholder="类型">
         <el-option label="所有" value="0"></el-option>
         <el-option label="铸造" value="-1"></el-option>
         <el-option label="卡环" value="2"></el-option>
         <el-option label="素描" value="3"></el-option>
       </el-select>
     </el-form-item>
     <el-form-item>
       <el-button type="primary">查询</el-button>
     </el-form-item>
     <el-form-item label="类型:">
       <el-select v-model="formInline.region" placeholder="类型" @change="goselect">
         <el-option label="全部" :value="0"></el-option>
         <el-option label="已完成" :value="1"></el-option>
         <el-option label="未完成" :value="2"></el-option>
       </el-select>
     </el-form-item>
   </el-form>-->
    <search @searchhandle="goselect"></search>
    <ul class="taskList" v-loading="loading" v-if="tabledata.length>0">
      <!-- 作业列表 -->
      <li class="taskItem" v-for="(item,index) in tabledata" :key="item.id">
        <span class="sign" v-show="item.cate.id==1">{{item.cate.name}}</span>
        <span class="sign kh" v-show="item.cate.id==2">{{item.cate.name}}</span>
        <span class="sign zz" v-show="item.cate.id==3">{{item.cate.name}}</span>
        <template v-if="!item.isstore">


          <el-button type="primary" size="mini" class="btn" @click="submitbtn(item,2)" v-if="!item.status">{{item.cate.id==3?"提交考试":"开始考试"}}</el-button>
          <el-button type="info" size="mini" class="btn" @click="submitbtn(item,2)" v-else>已提交</el-button>
        </template>
        <template v-else>
          <el-button type="success" size="mini" class="btn1" @click="golook(item)">查看成绩</el-button>
        </template>
        <div class="contents">
          <img :src="GLOBAL.BASE_URL+item.detail" class="detailimg" v-if="item.detail">
          <img src="../../../static/images/default1.png" class="detailimg" v-else>
          <div class="leftwrap">
            <div class="firstdiv">
              <div class="taskname">{{item.title}}</div>
              <div class="teachername teachername1">发布：{{item.author}}</div>

            </div>
            <div class="firstdiv">
              <div class="teachername teachername2">开始时间：{{item.start_time}}</div>
              <div class="teachername  teachername2">结束时间：{{item.end_time}}</div>
              <div class="teachername teachername1">时长：{{item.test_time}}</div>
              <div class="teachername teachername2" v-show="item.created_at1">提交时间：{{item.created_at1}}</div>
            </div>
            <!-- 素描 -->
            <div class="twodiv">
              <div class="leftdiv">
                <div class="tit">题目描述:</div>
                <div class="condiv">
                  {{item.description}}
                </div>
              </div>
            </div>
            <div class="twodiv">
              <div class="leftdiv" v-if="item.cate.id==3" :class="{'leftdiv1':item.cate.id==3}">
                <div class="tit">素描图片:</div>
                <div class="condiv">
                  <el-upload class="upload-demo" :action="uploadUrl" :on-preview="handlePictureCardPreview"  :on-exceed="exceed" :before-upload="beforeAvatarUpload" :file-list="item.student_answer1" :limit="2"   :on-success="(res, file, fileList)=>{return handleInfoSuccess(res, file, fileList, index)}"  :on-remove="(file, fileList)=>{return handleInfoRemove(file, fileList, index)}" list-type="picture-card">>
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
              </div>

              <div class="leftdiv" v-if="item.cate.id==3" :class="{'leftdiv2':item.cate.id==3}">
                <div class="tit"> 相关理解:</div>
                <div class="condiv">
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="item.textarea">
                  </el-input>
                </div>
              </div>
              <!-- 卡环图片 -->
              <div class="leftdiv" v-if="item.cate.id==2&&item.student_answer1&&item.student_answer1.length>0" :class="{'leftdiv1':item.cate.id==2}">
                <div class="tit">卡环图片:</div>
                <div class="condiv">
                  <!-- :file-list="item.student_answer" -->
                  <!-- :data-msg="item" ref="dataMsg" -->
                  <template v-if="item.student_answer1&&item.student_answer1.length>0">
                    <img :src="item.url" @click="handlePictureCardPreview(item)" alt="" v-for="item in item.student_answer1"  style="width:148px;height:148px;border-radius: 6px; margin-right:8px;margin-bottom:8px;border: 1px solid #c0ccda">
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div style="text-align: center;font-size:20px" v-else>暂无数据</div>
    <pagelist @currentchange="pagehandle"  :page-count="pageform.pages" :current-page="pageform.pageNum"  :total="pageform.total" :page-size="pageform.pageSize"></pagelist>
  </div>
</template>

<script>
    import search from './search'
    import test from './test'
    import pagelist from './pagelist'
    export default {
        mixins: [test],
        props: {

        },
        components:{
            search,
            pagelist
        },
        data() {
            return {
                region:'',
                params: {
                    class_id: this.$store.getters.getUserInfo.class_id,
                    page_size: 3,
                    page: 1,
                    type: 2,
                    cate:''
                },
            };
        },
        computed: {

        },
        created() {
            //this.gettasklist()
        },
        methods: {
            goselect(data) {
                var { region,cate} = data
                this.region = region
                // console.log(data)

                if (region == 0) {
                    this.params.cate=cate
                    this.gettestlist()
                }  else {
                    this.params = {
                        page_size: 3,
                        page: 1,
                        type: 2,
                        class_id: this.$store.getters.getUserInfo.class_id,
                        cate:cate,
                        sort:region>2?'score':'finish'
                    }

                    this.gettypelist(region)
                }
            },
        }
    };
</script>

<style  lang="less">
  .examination {
    .taskList {
      list-style: none;
      margin-bottom: 20px;

      .taskItem {
        position: relative;
        border: 1px solid #ebeef5;
        background-color: #fff;
        color: #303133;
        //   height: 200px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        margin-bottom: 20px;
        .sign {
          display: inline-block;
          position: absolute;
          top: 0;
          left: 0;
          width: 60px;
          line-height: 30px;
          height: 30px;
          background: #fd4e4e;
          color: #fff;
          font-size: 14px;
          text-align: center;
          border-radius: 0 0 10px 0;
        }
        .kh {
          background: #26ceaf;
        }
        .zz {
          background: #5b81ea;
        }
        .btn {
          position: absolute;
          top: 0;
          right: 0;
        }
        .btn1 {
          position: absolute;
          top: 40px;
          right: 0;
        }
        .detailimg {
          width: 240px;
          float: left;
        }
        .leftwrap {
          margin-left: 250px;
        }
        .contents {
          padding: 20px;
          padding-top: 40px;
          // height: 172px;
          box-sizing: border-box;
          overflow: hidden;
        }
        .firstdiv {
          overflow: hidden;
          margin-bottom: 10px;
          div {
            width: 40%;
          }
          .taskname {
            float: left;
            color: #5193f7;
            font-size: 16px;
            font-weight: bold;
          }
          .teachername {
            color: #303133;
            font-size: 15px;
            float: left;
          }
          .teachername1 {
            // width: 15%;
            width: 120px;
          }
          .teachername2 {
            width: 240px;
          }
        }
        .twodiv {
          // padding-top: 20px;
          overflow: hidden;
          .leftdiv {
            .tit {
              font-size: 15px;
              margin-bottom: 10px;
            }
            // width: 33.33%;
            width: 100%;
            float: left;
            .condiv {
              padding-right: 10px;
              // line-height: 30px;
              font-size: 15px;
              // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
              // -webkit-line-clamp: 2; /*显示的行数；如果要设置2行加...则设置为2*/
              // overflow: hidden;
              // text-overflow: ellipsis; /* 溢出用省略号*/
              // /*! autoprefixer: off */
              // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
              // /* autoprefixer: on */
            }
          }

          .leftdiv1 {
            // width: 70%;
            width: auto;
            margin-right: 20px;
          }
          .leftdiv2 {
            width: auto;
            width: 30%;
          }
        }
      }
    }
    .el-upload--picture-card {
      background-color: #fbfdff;
      border: 1px dashed #c0ccda;
      border-radius: 6px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 148px;
      height: 148px;
      line-height: 146px;
      vertical-align: top;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/assessment/examination.vue